import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import BrandPositioning from './components/BrandPositioning';
import IntelligenceMark from './components/IntelligenceMark';
import IndustryGrid from './components/IndustryGrid';
import CoreServices from './components/CoreServices';
import TrustClose from './components/TrustClose';
import Navbar from '../../components/feature/Navbar';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <BrandPositioning />
      <IntelligenceMark />
      <IndustryGrid />
      <CoreServices />
      <TrustClose />
    </div>
  );
}